import { fetchError, fetchStart, fetchSuccess } from '../../../redux/actions';
import { setAuthUser, setForgetPassMailSent, updateLoadUser } from '../../../redux/actions/Auth';
import React from 'react';
import axios from './config';

const JWTAuth = {
  onRegister: ({ name, email, password }) => {
    return dispatch => {
      dispatch(fetchStart());
      axios
        .post('auth/register', {
          email: email,
          password: password,
          name: name,
        })
        .then(({ data }) => {
          if (data.result) {
            localStorage.setItem('token', data.token.access_token);
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + data.token.access_token;
            dispatch(fetchSuccess());
            dispatch(JWTAuth.getAuthUser(true, data.token.access_token));
          } else {
            dispatch(fetchError(data.error));
          }
        })
        .catch(function(error) {
          dispatch(fetchError(error.message));
        });
    };
  },

  onLogin: ({ email, password }) => {
    return dispatch => {
      try {
        dispatch(fetchStart());
        axios
          .post('admin/api/login', {
            email: email,
            password: password,
          })
          .then(({ data }) => {
            if (data.info) {
              localStorage.setItem('admin-session', JSON.stringify(data));
              localStorage.setItem('token', data.access_token);
              localStorage.setItem('auto-reload', 'true');
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + data.access_token;
              dispatch(fetchSuccess());
              dispatch(setAuthUser(data));
              dispatch(JWTAuth.getAuthUser(true, data.access_token));
            } else {
              dispatch(fetchError(data.error));
            }
          })
          .catch(function(error) {
            dispatch(fetchError(error.response && error.response.data.message));
          });
      } catch (error) {
        dispatch(fetchError(error.response && error.response.data.message));
      }
    };
  },
  onLogout: () => {
    return dispatch => {
      localStorage.removeItem('token');
      localStorage.removeItem('admin-session');
      localStorage.removeItem('auto-reload');
      dispatch(setAuthUser(null));
      // axios
      //   .post('auth/logout')
      //   .then(({ data }) => {
      //     if (data.result) {
      //       dispatch(fetchSuccess());
      //       localStorage.removeItem('token');
      //       dispatch(setAuthUser(null));
      //     } else {
      //       dispatch(fetchError(data.error));
      //     }
      //   })
      //   .catch(function(error) {
      //     dispatch(fetchError(error.message));
      //   });
    };
  },

  getAuthUser: (loaded = false, token) => {
    return dispatch => {
      if (!token) {
        const token = localStorage.getItem('token');
        if (!token) {
          dispatch(updateLoadUser(true));
          return;
        }
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
      }
      dispatch(fetchStart());
      dispatch(updateLoadUser(loaded));
      axios
        .post('admin/api/login')
        .then(({ data }) => {
          if (data.info) {
            localStorage.setItem('admin-session', JSON.stringify(data));
            dispatch(fetchSuccess());
            dispatch(setAuthUser(data));
          } else {
            dispatch(updateLoadUser(true));
          }
        })
        .catch(function(error) {
          dispatch(updateLoadUser(true));
        });
    };
  },

  onForgotPassword: () => {
    return dispatch => {
      dispatch(fetchStart());

      setTimeout(() => {
        dispatch(setForgetPassMailSent(true));
        dispatch(fetchSuccess());
      }, 300);
    };
  },
  getSocialMediaIcons: () => {
    return <React.Fragment> </React.Fragment>;
  },
};

export default JWTAuth;
